"use strict";

import React from "react";
import { connect } from "react-redux";
import { FOREST_GREEN } from "../../stylesheets/colors";

const MoodTrackerModal = React.createClass({
  propTypes: {
    auth: React.PropTypes.object.isRequired,
    dispatch: React.PropTypes.func.isRequired,
  },

  render() {
    return (
      <div className='card my-4'>
        <div className='card-body'>
          <p className='mb-3' style={{ fontSize: "16px" }}>
            The mood tracker has moved to our new platform.{" "}
            <a
              href='/trackers/mood'
              target='_blank'
              rel='noopener noreferrer'
              style={{ color: FOREST_GREEN, fontWeight: "bold" }}>
              Click here to open the new Mood Tracker
            </a>
            . When finished, close the tab and click continue.
          </p>
        </div>
      </div>
    );
  },
});

export default connect((state) => ({
  auth: state.auth,
  trackerEntries: state.trackerEntries,
  moodEntry: state.modal.moodEntry,
}))(MoodTrackerModal);
